import * as pdfjsLib from 'pdfjs-dist/legacy/build/pdf';

pdfjsLib.GlobalWorkerOptions.workerSrc = `${process.env.PUBLIC_URL}/pdf.worker.min.js`;

const escapeHtml = (s) =>
    s.replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;');

// Extract an uploaded PDF's text into simple, editable HTML so it can be opened
// in the rich document editor (same experience as generated docs). Groups text
// items into lines by vertical position and pages by <hr page-break>. Layout is
// intentionally simplified — the goal is editable text, then re-render to PDF.
// Scanned/image-only PDFs have no text layer and yield an (almost) empty result.
export async function extractPdfHtml(arrayBuffer) {
    const pdf = await pdfjsLib.getDocument({ data: new Uint8Array(arrayBuffer.slice(0)) }).promise;
    const pages = [];

    for (let p = 1; p <= pdf.numPages; p++) {
        const page = await pdf.getPage(p);
        const content = await page.getTextContent();
        const items = content.items
            .filter((it) => typeof it.str === 'string')
            .map((it) => ({ str: it.str, x: it.transform[4], y: it.transform[5] }));
        // Top-to-bottom, then left-to-right.
        items.sort((a, b) => (Math.abs(b.y - a.y) > 2 ? b.y - a.y : a.x - b.x));

        const lines = [];
        let current = null;
        let lastY = null;
        for (const it of items) {
            if (lastY === null || Math.abs(it.y - lastY) > 3) {
                current = [];
                lines.push(current);
                lastY = it.y;
            }
            current.push(it.str);
        }

        const html = lines
            .map((l) => escapeHtml(l.join(' ').replace(/\s+/g, ' ').trim()))
            .map((t) => `<p style="margin:0 0 8px;">${t || '&nbsp;'}</p>`)
            .join('\n');
        pages.push(html || '<p>&nbsp;</p>');
    }

    const body = pages.join('\n<hr style="page-break-after:always;border:none;margin:0;" />\n');
    // Wrap so the re-rendered PDF has sane document margins/typography.
    return `<div style="font-family:Arial,Helvetica,sans-serif;font-size:12pt;line-height:1.5;color:#111;padding:8px;">\n${body}\n</div>`;
}
